import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import { Link } from 'react-router-dom';
import { getAllEvaUsers } from 'services/userServices';
import UsersInCellWidget from 'components/common/users/UsersInCellWidget';
import { useSortBe }  from 'hooks/useBeHandle';

const KpiTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  colSort,
  handleClickRow,
  buildDetailPath = id => '/kpi-balanced-scorecard/' + id
  // handleSort
}) => {
  const [users, setUsers] = useState([]);
  const isMounted = useRef(null);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    isMounted.current = true;
    const controller = new AbortController();
    getAllEvaUsers(controller.signal)
      .then(res => {
        if (!isMounted.current) return null;
        if (res?.length) setUsers(res);
      })
      .catch(err => {
        console.log('Error in user fetch', err);
      });
    return () => {
      isMounted.current = false;
      controller.abort();
    };
  }, []);

  const originColumns = [
    {
      accessor: 'id',
      Header: 'ID',
      isVisible: false
    },
    {
      accessor: 'name',
      Header: 'Name',
      Cell: rowData => {
        const { name, id } = rowData.row.original;
        return (
          <Link to={buildDetailPath(id)}>{name}</Link>
        );
      }
    },
    {
      accessor: 'description',
      Header: 'Description',
    },
    {
      accessor: 'inChargeUserId',
      Header: 'Person in Charge',
      Cell: rowData => {
        const { inChargeUserId } = rowData.row.original;
        return (
          <UsersInCellWidget usersText={inChargeUserId?.toString() } showName users={users} />
        );
      }
    }
  ];

  const { reNewColumns } = useSortBe(
    originColumns,
    colSort,
    setColumns,
    columns
  );

  useEffect(() => {
    reNewColumns();
  }, [colSort]);

  return (
    <>
      <PartialTable
        data={data}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        // beSortOption={{ canSort: true, handleSort: handleSort }}
        textAlign="center"
        handleClickRow={handleClickRow}
      />
    </>
  );
};

KpiTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  colSort: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleSort: PropTypes.func,
  handleClickRow: PropTypes.func,
  buildDetailPath: PropTypes.func
};

export default KpiTable;
